<template>
  <section class="history">
    <div class="layout-50-50 title">
      <PageTitle :title="$content.title" />
      <div class="spacer" />
    </div>
    <div class="layout-50-50">
      <aside>
        <PlayerVideo
          v-if="youtubeId !== null"
          class="history-video"
          :youtube-id="youtubeId"
        />
      </aside>
      <main
        class="contents"
      >
        <nav>
          <PillButton
            v-for="collection in $collections"
            :key="collection.id"
            :label="collection.label"
            :to="`/history/${collection.id}`"
            :year="collection.year"
            :disabled="!collection.available"
            :inverted="true"
          >
            <div :class="`collections-${collection.id}-product-gold-histoire`" />
          </PillButton>
        </nav>
        <div
          v-for="content in $currentCollection.history?.contents"
          :key="content.title"
          class="history-contents"
          :class="{outlined: content.outlined}"
          v-html="`<h3>${content.title}</h3>${content.text}`"
        />
      </main>
    </div>
    <div
      class="hr"
      :class="`collections-${$currentCollection.id}-common-floral-horizontal`"
    />
    <GeniusHotspot
      v-if="$currentCollection.history?.hotspot"
      class="genie"
    />
    <FaqSection />
  </section>
</template>

<script>
import PageTitle from '@/components/common/PageTitle.vue';
import FaqSection from '@/components/common/FaqSection.vue';
import PlayerVideo from '@/components/utils/video/PlayerVideo.vue';
import GeniusHotspot from '@/components/layouts/history/GeniusHotspot.vue';
import PillButton from '@/components/common/buttons/PillButton.vue';

export default {
  name: 'History',
  components: {
    PillButton,
    PageTitle,
    FaqSection,
    PlayerVideo,
    GeniusHotspot,
  },

  data() {
    return {

    };
  },

  computed: {
    youtubeId() {
      const coll = this.$currentCollection;
      const yt = `___${coll.id}_youtube_id`;
      return window[yt] || null;
    },
  },


  methods: {

  },
};
</script>

<style lang="stylus" scoped>

.history {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 89px);
  justify-content: center;
  padding: 0;
  +mobile() {
    padding: 0 0 30px;
  }

  .layout-50-50 {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    & > * {
      padding: 40px 0 20px;
      +mobile() {
        padding: 20px 0;
      }
    }

    +mobile() {
      display: flex;
      flex-direction: column;
      gap: 40px;
    }

    & > *:last-child {
      background: var(--white-color);
      transition: background 200ms ease-in-out, color 200ms ease-in-out;
      color: var(--inverted-text-color);
    }

    & > *:first-child {
      background: var(--main-color);
      transition: background 200ms ease-in-out, color 200ms ease-in-out;
    }

    .spacer {
      +mobile() {
        display: none;
      }
    }

    .history-video {
      +desktop() {
        position: sticky;
        top: 40px;
        margin-bottom: 30px;
      }
    }
  }

  main.contents {
    padding: 40px 80px;
    display: flex;
    flex-direction: column;

    +mobile() {
      padding: 20px 15px;
    }

    nav {
      display: flex;
      flex-wrap: nowrap;
      gap: 20px;
      margin-bottom: 30px;

      +mobile() {
        order: +1;
        justify-content: center;
        & > .router-link-active {
            display: none;
        }
      }

    }

    div.history-contents {
      margin: 10px 0;
      &.outlined {
        border: 1px solid var(--main-color);
        padding: 20px 20px 0;
        border-radius: 10px;
      }
    }

    & >>> p {
      text-align: left;
      font-size: 15px;
      line-height: 1.4;
      margin-bottom: 20px;
    }
    & >>> h3 {
      text-align: left;
      font-size: 20px;
      font-weight: 700;
      margin-top: 50px;
      margin-bottom: 15px;
    }

    & >>> h3:first-child {
      margin-top: 0;
    }
  }

  .hr {
    width: 100%;
    aspect-ratio: unset;;
    margin: 0;
    background-repeat: repeat-x;
    margin-top: -15px;
  }

  .genie {
    width: 100%;
  }
}
</style>
